module.exports = __webpack_public_path__ + "img/cedar.622d318.svg";